import React from "react";

export default function Welcome() {
	return (
		<div>
			<h4 className=" font-fascinate text-4xl font-bold uppercase">You are Welcome to my Portfolio</h4>
		</div>
	);
}
